export const getListAssetMixin = {
  data() {
    return {
      listAsset: [],
      listAssetLoading: false,
    }
  },
  methods: {
    getListAsset() {
      this.listAssetLoading = true;
      this.$http
        .get(process.env.VUE_APP_API_URL + "/profile/asset")
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.listAsset = response.data;
              const queryParams = this.$route.query;

              if (queryParams.asset_id != undefined) {
                this.listAsset.forEach(data => {
                  if (data.id == queryParams.asset_id) {
                    this.formData.asset = data;
                    this.formData.asset_id = data.id
                  }
                });
              }
            }
          }
        })
        .finally(() => {
          this.listAssetLoading = false;
        });
    },
  }
};